import React from 'react';
import LoadingSpinner from "../../../components/LoadingSpinner";
import Pagination from "../../../components/Pagination";
import Translate from "../../../components/Translate";

const FilesTable = ({
                        isLoading,
                        rows,
                        currentUser,
                        currentPage,
                        pageNumbers,
                        handleNextPage,
                        handlePageClick,
                        handlePreviousPage,
                        handleRowsPerPageChange,
                        rowsPerPage,
                        totalPages,
                        filteredFiles,
                    }) => {
    return (
        <div className="project-files">
            {isLoading ? (
                <LoadingSpinner />
            ) : (
                <>
                    <table>
                        <thead>
                        <tr>
                            <th><Translate language={currentUser.language} text="keyName" /></th>
                            <th><Translate language={currentUser.language} text="description" /></th>
                            <th><Translate language={currentUser.language} text="preview" /></th>
                            <th><Translate language={currentUser.language} text="action" /></th>
                        </tr>
                        </thead>
                        <tbody>{rows}</tbody>
                    </table>
                    <Pagination
                        currentPage={currentPage}
                        pageNumbers={pageNumbers}
                        handleNextPage={handleNextPage}
                        handlePageClick={handlePageClick}
                        handlePreviousPage={handlePreviousPage}
                        handleRowsPerPageChange={handleRowsPerPageChange}
                        rowsPerPage={rowsPerPage}
                        totalPages={totalPages}
                        totalResources={filteredFiles.length}
                    />
                </>
            )}
        </div>
    );
};

export default FilesTable;
